import { render, staticRenderFns } from "./ecgMonitor.vue?vue&type=template&id=e330e8de&scoped=true"
import script from "./ecgMonitor.vue?vue&type=script&lang=js"
export * from "./ecgMonitor.vue?vue&type=script&lang=js"
import style0 from "./ecgMonitor.vue?vue&type=style&index=0&id=e330e8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e330e8de",
  null
  
)

export default component.exports